module.exports = __webpack_public_path__ + "static/img/大雪.dd0e11c1.svg";